export default "__VITE_ASSET__BhJag0Ij__"